
import crypto from '@/common/resources/crypto.js'
import {UPDATE_CURRENT_PATH} from "../../store/mutation-types";
import store  from '@/store/index'
import _ from 'lodash';
import swal from 'sweetalert2';

export default  {
// needed to set up as plugin, used by Vue to make it global in main
  install: function(Vue) {
    Object.defineProperty(Vue.prototype, '$ociUtils', { value: this });
    },
  global: {
    showSwal(msg) {

      swal({
        title: msg.title,
        text: msg.text,
        type: msg.type,
        timer: msg.timer,
      })
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },
    arrayIsEmptyOrEmptyObject(arrayParam) {
      if (arrayParam) {
        if (arrayParam.length > 0) {
          return this.isEmpty(arrayParam[0])
         }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },

    formatCountdown(count){
      let minutes = Math.trunc(count / 60).toString(10);
      let seconds = (count % 60).toString(10);
      let minuteFormat = "00";
      let secondsFormat = "00";
      let countDownFormat="";
      if(minutes.length  === 1 && minutes!== "0"){
        minuteFormat =  "0"+minutes;
      }
      else if(minutes.length  > 1){
        minuteFormat =   minutes;
      }
      if(seconds.length === 1 && seconds !== "0"){
        secondsFormat = "0"+seconds
      }
      else if (seconds.length>1){
        secondsFormat = seconds
      }
      countDownFormat = minuteFormat+":"+secondsFormat
      return countDownFormat;
    },
    /**
     * Performs a this.ociLog() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvLog: function(...args)
    {
      //Log based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.log(...args);
      }
    },
    /**
     * Performs a console.assert() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvAssert: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.assert(...args);
      }
    },
    /**
     * Performs a console.debug() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvDebug: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.debug(...args);
      }
    },
    /**
     * Performs a console.error() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvError: function(...args)
    {
      console.error(...args);
    },
    /**
     * Performs a console.group() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvGroup: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.group(...args);
      }
    },
    /**
     * Performs a console.groupEnd() with some input parameters if the current app environment is local development or deploy test
     */
    ociEnvGroupEnd: function()
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.groupEnd();
      }
    },
    /**
     * Performs a console.info() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvInfo: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.info(...args);
      }
    },
    /**
     * Performs a console.table() with some input parameters if the current app environment is local development or deploy test
     * @param tabularData - An iterable containing strings and/or objects to be logged
     */
    ociEnvTable: function(tabularData)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.table(tabularData);
      }
    },
    /**
     * Performs a console.trace() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvTrace: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.trace(...args);
      }
    },
    /**
     * Performs a console.warn() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvWarn: function(...args)
    {
      console.warn(...args);
    },

  },
  regex:{
    applyMinimumReqRegex(pass){
      let minimumPattern = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`\\-]).+$/
      return minimumPattern.test(pass)
    },
    onlyAllowedPattern(pass){
      let onlyAllowedPattern = /[\w+=^$*.\[\]{}()?"!@#%&/\\,><':;|_~`\\-]{9,80}/
      return onlyAllowedPattern.test(pass)
    },
  },
  broker: {
    pdfViewer(response){
      if(!response){
        console.warn("getPDF Error Occurred");
      }
      else {
        const blob = new Blob([response.data], {type: "application/pdf"});
        const url = URL.createObjectURL(blob);
        window.open(url);

        /**
         * Please donot remove the commented iframe code
         */
        /*let x = window.open();
          x.opener = null;
        x.referrer = null;
        let iframe = x.document.createElement('iframe');
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.style = "border: 0";
        iframe.src = url;
        x.document.title = "OneClose Forms";
        x.document.body.appendChild(iframe);*/
      }
    },

    imageViewer(response){
      if(!response){
        console.warn("getPDF Error Occurred");
      }
      else {
        const blob = new Blob([response.data], {type: "image/png"});
        const url = URL.createObjectURL(blob);
        window.open(url);

        /**
         * Please donot remove the commented iframe code
         */
       /* let x = window.open();
        let iframe = x.document.createElement('iframe');
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.style = "border: 0";
        iframe.src = url;*/
        // x.document.title = "OneClose Forms";
        // x.document.body.appendChild(iframe);
      }
    },

    calculateMortgagePayment(loanApplication, interest) {
      //ensure required variables for calculation are present and data is of valid type
      let variablesPresent =  [];
      let runCalculation = true;
      // this.ociLog("Mortgage object interest",loanApplication.mortgage.interestRate)
      // this.ociLog("Mortgage param interest",interest)
      // this.ociLog("Mortgage amortizationYears",loanApplication.mortgage.amortizationYears)
      // this.ociLog("Mortgage totalLoanAmount",loanApplication.mortgage.totalLoanAmount)
      // this.ociLog("Mortgage paymentFrequency",loanApplication.mortgage.paymentFrequency)
      let interestRate;
      if(this.isRealNumber(interest)){
        interestRate = interest;
      }
      else {
        interestRate = loanApplication.mortgage.interestRate;
      }
      variablesPresent.push(this.isRealNumber(interestRate))
      variablesPresent.push(this.isRealNumber(loanApplication.mortgage.amortizationYears) && loanApplication.mortgage.amortizationYears> 0)
      variablesPresent.push(this.isStringValue(loanApplication.mortgage.paymentFrequency))
      variablesPresent.push(this.isRealNumber(loanApplication.mortgage.totalLoanAmount))

      for(let i=0; i<variablesPresent.length;i++){
        if (variablesPresent[i]===false){
          runCalculation=false}
      }
      // this.ociLog("Required Variables Present "+variablesPresent)
      if(runCalculation){


      let paymentFrequency = this.paymentsPerYear(loanApplication.mortgage.paymentFrequency);

      let totalInterestPeriods = paymentFrequency * loanApplication.mortgage.amortizationYears;
      interestRate = interestRate / 100;
      let periodicInterestRate = 0;
      let payment=0;
      //accelerated by weekly payments use monthly interest periods and divides the payment by 2
      if(loanApplication.mortgage.paymentFrequency === "Acc-biweekly"){
        periodicInterestRate = (Math.pow((1+(interestRate/2)), (1/6))) - 1;
        totalInterestPeriods = 12 * Number(loanApplication.mortgage.amortizationYears);
        payment = ((loanApplication.mortgage.totalLoanAmount*periodicInterestRate)/(1-(Math.pow((1+periodicInterestRate),(-1 * totalInterestPeriods)))));
        payment = (payment / 2).toFixed(3);
      }
      //accelerated weekly payment use monthly interest periods and divides the payment by 4
      else if (loanApplication.mortgage.paymentFrequency === "Acc-weekly") {
        periodicInterestRate = (Math.pow((1+(interestRate/2)), (1/6))) - 1;
        totalInterestPeriods = 12 * Number(loanApplication.mortgage.amortizationYears);
        payment = ((loanApplication.mortgage.totalLoanAmount*periodicInterestRate)/(1-(Math.pow((1+periodicInterestRate),(-1 * totalInterestPeriods)))));
        payment = (payment / 4).toFixed(3);
      }
      else {
        periodicInterestRate = (Math.pow((1+(interestRate/2)), (2/paymentFrequency))) - 1;
        payment = ((loanApplication.mortgage.totalLoanAmount*periodicInterestRate)/(1-(Math.pow((1+periodicInterestRate),(-1 * totalInterestPeriods))))).toFixed(3);
      }
      if(this.isRealNumber(payment)){
        // return _.ceil(payment, 2);
        return _.round(payment, 2);
      }
      else {
        return null;
      }

      }
      else {
        return null;
      }
      // this.updateNetMonthlyIncome(num);
      // this.updateSubjectOfLoanState();
    },
    /**
     *
     * @param loanApplication
     * @param interest
     * @param clientFees
     * @returns {null|number}
     */
    calculateAPR(loanApplication, interest, clientFees){
      if(loanApplication == null){
        return null;
      }

      //ensure required variables for calculation are present and data is of valid type
      let variablesPresent =  [];
      let runCalculation = true;
      let interestRate;
      if(this.isRealNumber(interest)){
        interestRate = interest;
      }
      else {
        interestRate = loanApplication.mortgage.interestRate;
      }
      variablesPresent.push(this.isRealNumber(interestRate));
      variablesPresent.push(this.isRealNumber(loanApplication.mortgage.amortizationYears) && loanApplication.mortgage.amortizationYears> 0);
      variablesPresent.push(this.isStringValue(loanApplication.mortgage.paymentFrequency));
      variablesPresent.push(this.isRealNumber(loanApplication.mortgage.totalLoanAmount));

      for(let i=0; i<variablesPresent.length;i++){
        if (variablesPresent[i]===false){
          runCalculation=false}
      }
      if(runCalculation){

        /*APR is always calculated based on monthly payments*/
        let paymentFrequency = 12;
        let totalInterestPeriods = paymentFrequency * loanApplication.mortgage.amortizationYears;
        interestRate = interestRate / 100;
        let periodicInterestRate = 0;
        let payment=0;

        /*Calculating the periodic interest rate*/
        periodicInterestRate = (Math.pow((1+(interestRate/2)), (2/paymentFrequency))) - 1;
        /*Calculating the monthly mortgage payment*/
        payment = ((loanApplication.mortgage.totalLoanAmount*periodicInterestRate)/(1-(Math.pow((1+periodicInterestRate),(-1 * totalInterestPeriods))))).toFixed(3);


        /*AMortizatoin Calcs*/

        let termMonths = loanApplication.mortgage.termYears; //TODO: Term is in months in the backend; column label is incorrect
        let balance = loanApplication.mortgage.totalLoanAmount;
        let endingBalance= 0;
        let principal = 0;
        let period = 0;     //How many periods have elapsed

        let totalPrincipalOverTerm = 0;
        let totalInterestOverTerm = 0;


        /*Calculating payments for every month*/
        for(let i = 0; i < termMonths ;i++){
          endingBalance = balance;

          //accounts for the final payment of the am schedule, paying off that balance with interest on it
          if(endingBalance < Number(payment)) {
            totalInterestOverTerm += Number((endingBalance * periodicInterestRate).toFixed(2));
            principal = endingBalance;
            period = i + 1;
            payment = (Number(interest) + Number(principal)).toFixed(2);
            balance = 0;
          }else {
            totalInterestOverTerm += Number( (endingBalance * periodicInterestRate).toFixed(2) );
            principal = (Number(payment) - (endingBalance * periodicInterestRate)).toFixed(2);
            period = i + 1;
            balance = (endingBalance - principal).toFixed(2);
            totalPrincipalOverTerm += Number(balance);
          }

          if(endingBalance === 0) {
            break;
          }

        }

        /*Calculating Total Fees*/
        let totalFees = 0;
        if(Array.isArray(clientFees)) {
          for (let i = 0; i < clientFees.length; i++) {
            if(clientFees[i].includeInAPR){
              totalFees += clientFees[i].feeAmount;
            }
          }
        }

        /*Calculation APR
          APR = C/(Term in years/Average Prin)
          C = total interest for the 60 month term + Fees
          Term term in Years
          Avg Prin = Sum of principal over term/term months
        * */

        let APR =  (Number( (totalInterestOverTerm + totalFees)/ ( (termMonths/12) * (totalPrincipalOverTerm/termMonths) ) ) * 100).toFixed(3);
        return Number(APR);

      }
      else {
        return null;
      }

    },
    paymentsPerYear(frequency){
      var divider = 1;
      if(frequency === "Monthly"){
        divider = 12;
      }
      if(frequency === "Semi-monthly"){
        divider = 24;
      }
      if(frequency === "Weekly"){
        divider = 52;
      }
      if(frequency === "Bi-weekly"){
        divider = 26;
      }
      if(frequency === "Acc-weekly"){
        divider = 52;
      }
      if(frequency === "Acc-biweekly"){
        divider = 26;
      }
      if(frequency === "Annually"){
        divider = 1;
      }
      if(frequency === "Semi-annually"){
        divider = 2;
      }
      if(frequency === "Quarterly"){
        divider = 4;
      }
      return divider;
    },
    /**
        Ensure value is a number and  not boolean, not empty string, not infinite
     */
    isRealNumber(value){
      return !isNaN(parseFloat(value)) && isFinite(value) && value
    },
    /**
     Ensure value is string, not null, not empty and not undefined
     */
    isStringValue(value){
     if(value!== null && value !== '' && typeof value!=='undefined')
     {return  true}
     else {return false}
    }
  },

  string:{
    /**
     Ensure value is string, not null, not empty and not undefined
     */
    isStringValue(value){
      if(value!== null && value !== '' && typeof value!=='undefined')
      {return  true}
      else {return false}
    },
    /**
     * Remove preceding and trailing whitespace from a string
     * @param string - gets converted to a string if not a string
     * @returns string without outer whitespace
     */
    trimSpace(string){
      if(typeof string !== 'string'){
        string = string.toString();
      }
      //Remove preceding and trailing whitespace
      string = string.trim();
      return string;
    }
  },


  messaging: {
    generateChatId: function (){
      let date = new Date();
      let timestamp = date.getTime();
      let randomStart= Math.random().toFixed(4).split('.')[1];
      let uniqueNumber = +randomStart+timestamp;
      return uniqueNumber;
    },
    //format sent time
    formatChatTime: function (dateTime){
      // apply rules for am or pm and adjusting javascript zero  starting and adding 0 to months, minutes, dates etc
      let month = (dateTime.getMonth()+1)
      let date = dateTime.getDate()
      let hour =dateTime.getHours()
      let minutes = dateTime.getMinutes()
      let dateZero='';
      let minuteZero='';
      let monthZero='';

      let meridiem = '';
      // logic for adding am or pm
      if (hour >11){
        meridiem='pm'
        if(hour>12){
          hour = hour-12;
        }
      }
      else {meridiem='am'}
      //logic for adding zeros
      if (date<10){dateZero='0'}
      if (minutes<10){minuteZero='0'}
      if(month<10){monthZero='0'}
      // create date string

      let formatedDateTime =
        dateZero+date+'/'+monthZero+month+'/'+dateTime.getFullYear()+' '
        +hour+':'+minuteZero+minutes+' '+meridiem;
      return formatedDateTime;
    },
    orderMessagesByCreatedFromEpoch(messages){
      messages.sort(function(a,b) {
          let comparison= 0;
          let aUpdate = a.createdFromEpoch
          let bUpdate = b.createdFromEpoch
          if (aUpdate>bUpdate){
            comparison = 1;
          }
          else if (aUpdate<bUpdate){
            comparison = -1;
          }
         return comparison;
        }
      )
    }
  },
  appState:{
      saveAppStateLocalStorage(state, currentPage){
        let userId = store.getters.appUser.userId
        let stringState = JSON.stringify(state);
        let encryptedState =  crypto.encryptData(stringState)
        localStorage.setItem("app-d"+userId,encryptedState)
        let userData = JSON.stringify({lastPage:currentPage,userId:userId,appReload:true})
        let encryptedUserData =  crypto.encryptData(userData)
        localStorage.setItem("user-d"+userId,encryptedUserData)
      },
    cleanAppStateReload(){
      let userId = store.getters.appUser.userId
      localStorage.removeItem("app-d"+userId);
      localStorage.removeItem("user-d"+userId);

    },
    //deprecated since using session management techniques
    loadAppStateLocalStorage(){
      let userId = store.getters.appUser.userId
      let encryptedAppState =  localStorage.getItem("app-d"+userId);
      let localAppState = JSON.parse(crypto.decryptData(encryptedAppState))
      localAppState.appUser=store.getters.appUser;
      localAppState.userToken=store.getters.userToken;
      store.replaceState(localAppState);
    },
    /**
     * Used to remove from user's localStorage previous data stored there but now is store in session Storage.
     */
    clearDeprecatedData(){
      let userId = store.getters.appUser.userId
      localStorage.removeItem("user-token");
      localStorage.removeItem("profilePicturePath");
      localStorage.removeItem("user-d0");
      localStorage.removeItem("app-d0");
      localStorage.removeItem("app-d"+userId);
      localStorage.removeItem("user-d"+userId);
    }

  }

}
